
import React, { useEffect, useState } from 'react'

import Axios from 'axios'
import { Link } from 'react-router-dom'
import Loader from '../../../Loader/Loader'
import SingleLeagueTemplate from './LeagueTemplates/SingleLeagueTemplate'

function AllLeagues({topLeaguesFB}) {

	const [leagues, setLeagues] = useState()
	const [filteredLeagues, setFilteredLeagues] = useState([])
	const [searchTerm, setSearchTerm] = useState("");
	const [requestCount, setRequestCount] = useState(0)

	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {

		async function fetchLeagues() {
			setIsLoading(true)
			try {
				const response = await Axios.get("https://api-football-v1.p.rapidapi.com/v2/leagues/current", 
				{headers: {
					"x-rapidapi-key": "4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45"
				}}
				)
				if (response.data) {
					setLeagues(response.data.api.leagues)
					setFilteredLeagues(response.data.api.leagues)
				}
				console.log(response.data, "Leagues");
			} catch (error) {
				console.log(error);
			}
			setIsLoading(false)

		}
		fetchLeagues()

	}, [])

	useEffect(() => {

		if (requestCount) {

			const filteredLeagues = leagues.filter(league => {
				return league.name.toLowerCase().trim() .includes(searchTerm);
			})
			setFilteredLeagues(filteredLeagues)
		}

	}, [requestCount, leagues])

	function handleInput(e) {

		if (leagues) {
			setSearchTerm(e.target.value);
			if (e.target.value.trim() !== "") {
				setRequestCount(requestCount+1)
			} 
		}

	}

	if (isLoading) return <Loader />

	return (
		<div>


			<div className="md-form">
				<input onChange={handleInput} type="text" id="search-leagues" className="form-control" />
				{!searchTerm && <label htmlFor="search-leagues">Søk ligaer</label>}
			</div>

			<div className="row">
				{filteredLeagues.map((league, index) => {
					return <SingleLeagueTemplate key={index} league={league} topLeaguesFB={topLeaguesFB} />
				})
				}
			</div>
		</div>
	)
}
export default AllLeagues
